import {mapGetters} from 'vuex';

export default {
    name: 'cardSection',
    props: {
        data: {
            type: Array,
            default: []
        },
        title: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapGetters('glb', ['glb'])
        }
}
